import React, { useEffect, useState } from "react";
import { Radio, Space } from 'antd-mobile';
import api from "../../../../api";
import "./style.less";
import { isWxOrAli } from "../../../../utils/env";

const WechatChannel = { channelId: 1, channelName: "微信", balance: null, enable: true }
const AlipayChannel = { channelId: 2, channelName: "支付宝", balance: null, enable: true }

const PayChannel = (props) => {
  const { setPayChannel } = props

  const [channels, setChannels] = useState([])

  // 判断当前是微信 or 支付宝
  const aliOrWx = isWxOrAli();
  const disableChannel = aliOrWx === 'wechat' ? 2 : 1;

  const refreshPayChannel = async () => {
    const resp = await api.orderPayChannel()
    if (resp?.data?.code === 0) {
      setChannels(resp.data.data)
    } else {
      setChannels([WechatChannel])
    }
  }

  const handleOnChange = (v) => {
    const channel = channels.find((ele) => {
      return ele.channelId === v
    })

    setPayChannel(channel)
  }

  useEffect(() => {
    refreshPayChannel()
  }, [])

  return (
    <div className="pay-channel-wrapper">
      <div className="pay-channel-header">
        <h3>支付方式：</h3>
      </div>

      <div className="pay-channel-radio">
        <Radio.Group
          onChange={v => {
            handleOnChange(v)
          }}
        >
          <Space direction="vertical">
            {
              channels.map((item, index) => (
                item.enable && item.channelId !== disableChannel ?
                  <Radio key={index} value={item.channelId}>
                    {item.channelName}
                    {
                      // 钱包需要显示余额
                      item.channelId === 3 ? <span>（余额: {item.balance / 100}）</span> : undefined
                    }
                  </Radio>
                  :
                  undefined
              ))
            }
          </Space>
        </Radio.Group>
      </div>
    </div>
  )
}

export default PayChannel